import { reduxForm, InjectedFormProps } from 'redux-form';


export function withDynamicForm<FormData = {}, P = {}>(
  formName: string,
  Component: React.ComponentType<InjectedFormProps<FormData, P> & P>
) {
  return reduxForm<FormData, P>({
    form: formName,
    destroyOnUnmount: false, // optional
  })(Component);
}